import { render, staticRenderFns } from "./Quills.vue?vue&type=template&id=cfe9ef14&scoped=true"
import script from "./Quills.vue?vue&type=script&lang=js"
export * from "./Quills.vue?vue&type=script&lang=js"
import style0 from "./Quills.vue?vue&type=style&index=0&id=cfe9ef14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe9ef14",
  null
  
)

export default component.exports